/**
 * Item 4b (2026-07-21): the category dropdown's three tiers - Suggested
 * (ranked, from GET /categories/suggest), Used in this RFP (categories
 * chosen on OTHER lines), and All categories (the full, unrestricted,
 * search-filtered list - unchanged from before Item 4/Defect B). Selection
 * from any tier is equally valid; tiers are ORDERING, never filtering - the
 * same category can legitimately appear in more than one tier.
 */
import { searchCategories } from './categorySearch';

// Categories chosen on OTHER lines in the current set, excluding the row
// being edited itself.
export const usedCategoryCodes = (lineItems, excludeIndex) => {
  const codes = new Set();
  (lineItems || []).forEach((item, index) => {
    if (index === excludeIndex) return;
    const code = (item && item.spend_category ? String(item.spend_category) : '').trim();
    if (code) codes.add(code);
  });
  return codes;
};

/**
 * `suggestions` is the raw GET /categories/suggest response
 * ({custom_code, category_name, score}[]) - mapped back to the full
 * category object (for flag/l1_category/etc., needed by the existing
 * option rendering) via `categories`. A suggestion whose code no longer
 * exists in the master list (stale) is silently dropped.
 */
export const buildCategoryTiers = ({ categories, suggestions, usedCodes, search }) => {
  const byCode = new Map((categories || []).map((c) => [c.custom_code, c]));

  const suggestedTier = searchCategories(
    (suggestions || []).map((s) => byCode.get(s.custom_code)).filter(Boolean),
    search
  );

  const usedTier = searchCategories(
    (categories || []).filter((c) => usedCodes && usedCodes.has(c.custom_code)),
    search
  );

  const allTier = searchCategories(categories, search);

  return { suggested: suggestedTier, used: usedTier, all: allTier };
};
